import React from 'react';
import { useSearchParams } from 'react-router-dom';
import inflection from 'inflection';

import ParsedHtml from '@buyside/components/presentation/ParsedHtml/parsedHtml';

import styles from '@buyside/components/presentation/FundProfileIndexPage/FundProfileIndexItem/FundProfileIndexItemHighlights/fundProfileIndexItemHighlightsStyles.scss';

const FundProfileIndexItemHighlights: React.FC<{ highlights: string }> = ({ highlights }) => {
  const [searchParams] = useSearchParams();
  const searchedText = searchParams.get('text');

  if (!searchedText) return null;

  const highlightText: React.ReactElement[] = [];

  Object.entries(JSON.parse(highlights) as { [key: string]: string[] }).forEach(
    ([key, value], idx) => {
      if (key === 'description') return;

      highlightText.push(
        <div key={`${key + idx}`}>
          <div className={styles.highlightCategory}>
            {(key === 'press' ? 'Press Releases' : inflection.titleize(key)) +
              ' that match "' +
              searchedText +
              '".'}
          </div>
          <div className={styles.highlightItems}>
            {value.map((line: string, idx: number) => (
              <ParsedHtml key={idx} html={line}>
                {({ content }): React.ReactNode => <div>{content}</div>}
              </ParsedHtml>
            ))}
          </div>
        </div>
      );
    }
  );

  return <div className={styles.highlights}>{highlightText}</div>;
};

export default FundProfileIndexItemHighlights;
